// extracted by mini-css-extract-plugin
export default {"heading":"Vz-z","corrected":"Wz-z","redirectVerbiageContainer":"Xz-z","redirectVerbiageText":"Yz-z"};